



























import Vue from 'vue'
import settings from "@/settings.coffee"

export default {
  name: 'FileList'
  props:
    model: null
    objectId: null
  data: ()->
    return {
      files: [],
      newFiles: []
    }
  computed:
    allFiles: ()->
      ret = []
      if @files
        for f in @files
          ret.push(f)
      for f in @newFiles
        ret.push(f)
      return ret        
  methods:
    fileUrl: (index)->
      console.log("settings.backend_url", settings.backend_url)
      if @files? and @files[index]?
          settings.backend_url+@files[index].url
    get_files: ()->
      if @objectId? and @objectId != ''
          formData = new FormData()
          formData.append('model', @model)
          formData.append('objectId', @objectId)
          ret = await Vue.http.post(settings.file_list_url, formData)
          console.log(ret)
          @files = ret.body.result.map (el)->
            el.existInDb = true
            return el
      else
        @files = []
               
  mounted: ()->
    console.log("file_upload mounted")
    @get_files()
    return
  watch:
    objectId: ()->
      console.log("objectId", @objectId)
      @get_files()
}
